import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { usePolicyPageStyles } from './PolicyPage.styles';
import { PolicyBreadcrumb } from '../PolicyBreadcrumb';
import { PolicyBrowser } from '../PolicyBrowser';
import { createPolicyApiClient } from '../../services/api/policyApiClient';
import { useImpersonationLink } from '../../services/hooks/useImpersonationLink';
import { getImpersonationEmail } from '../../utils/impersonation';

export const PolicyPage: React.FC = () => {
    const styles = usePolicyPageStyles();
    const homeLink = useImpersonationLink('/');
    const { search } = useLocation();
    const { instance, accounts } = useMsal();
    const account = accounts[0];
    const impersonationEmail = getImpersonationEmail(search);

    const apiClient = useMemo(
        () => createPolicyApiClient(instance, account, impersonationEmail),
        [instance, account, impersonationEmail]
    );

    return (
        <div className={styles.container}>
            <PolicyBreadcrumb items={[{ label: 'New Hire Hub', ...homeLink }]} current="HR Policies" />

            <div className={styles.content}>
                <PolicyBrowser apiClient={apiClient} />
            </div>
        </div>
    );
};
